import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import PageView from 'src/components/PageView/PageView';
import { useAnalytics } from 'src/sdk/analytics/AnalyticsContext';
import { makePrivateStackIntroPathname } from 'src/sdk/PATHS';
import { ReachedIntroStepSchema } from 'src/sdk/schemas';
import messages from '../Intro.messages'

const MaxRows: React.FC = (props) => {

  const params = useParams();
  const analytics = useAnalytics();

  return (
    <>
      <Helmet defer={false}>
        <title>Intro - Maximum # of rows</title>
        <meta
          name="description"
          content="Instructions on how to make a stack. You can have as many as 7 rows"
        />
      </Helmet>
      <PageView
        onPageView={() => analytics.page({
          name: 'MaxRows',
          category: 'Intro'
        })}
      />
      <div className="uppercase-label fadeInFromRight">
        Intro
      </div>
      <h1 className="fadeInFromRight second">
        <FormattedMessage
          values={{ br: <br /> }}
          {...messages.maxRowsHeading}
        />
      </h1>
      <p className="fadeInFromRight third">
        <FormattedMessage
          values={{ br: <br /> }}
          {...messages.maxRowsBody}
        />
      </p>
      <Link
        to={{
          pathname: makePrivateStackIntroPathname({
            ...params,
            stepId: ReachedIntroStepSchema.enum.shirtBack
          }),
        }}
        className="btn btn-primary"
      >
        <FormattedMessage
          {...messages.nextButtonLabel}
        />
      </Link>
    </>
  );
}

export default MaxRows
